import React from 'react';

export const FormGroup = ({ label, children, error }) => (
  <div className="form-group">
    {label && <label className="form-label">{label}</label>}
    {children}
    {error && <span className="form-error">{error}</span>}
  </div>
);

export const FormInput = ({ label, type = 'text', value, onChange, placeholder, required = false, error, onBlur, maxLength }) => (
  <FormGroup label={label} error={error}>
    <input 
      type={type}
      className={`form-input ${error ? 'form-input-error' : ''}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={required}
      maxLength={maxLength}
    />
  </FormGroup>
);

export default FormGroup;
